<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <ul class="left-menu">
                    <li @click="handleChange(0)" :class="{'active':active('0')}">
                        全部
                    </li>
                    <li @click="handleChange(1)" :class="{'active':active('1')}">
                        班主任
                    </li>
                    <li @click="handleChange(2)" :class="{'active':active('2')}">
                        副班主任
                    </li>
                </ul>

                <div style="padding-top: 20px">
                    <div style="border-bottom: 1px dashed rgba(22,25,49,0.5)"></div>
                    <el-form label-position="left">
                        <el-form-item label="员工">
                            <el-select v-model="filter.employee_id" clearable placeholder="请选择员工" filterable remote
                                       :remote-method="handleSearchEmployee" @change="handleChange(filter.employeeType_id)">
                                <el-option
                                        v-for="item in search_employees"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div style="padding:10px 0px 0px 10px" v-if="filter.employeeType_id===3 && powers.includes(167)">
                <el-button @click="handleStoreHeadTeacher()">新建班主任</el-button>
            </div>
            <div style="padding:10px 0px 0px 10px" v-else-if="filter.employeeType_id===2 ">
                <el-button @click="handleStoreSecondHeadTeacher()" v-if="powers.includes(168)">新建副班主任</el-button>
                <el-button @click="handleDistributionSecondHeadTeacher()"  v-if="powers.includes(169)">分配副班主任</el-button>
            </div>

            <div class="m-portlet__body" :style="{'height':$store.state.config.clientHeight-96-101.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderEmployees"
                          style="width: 100%"
                          :height="$store.state.config.clientHeight-96-61.59-2.2-2-13-45"
                          size="middle"
                >
                    <el-table-column prop="id" label="成员编号"></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="phone" label="手机号码"></el-table-column>
                    <el-table-column  label="支付二维码" v-if="filter.employeeType_id===0">
                        <template slot-scope="scope">

                                <div v-if="scope.row.pay_url">
                                    <el-popover
                                            placement="right"
                                            trigger="click">
                                        <img :src="scope.row.pay_url" style="width: 500px;height: 500px">
                                        <div slot="reference" @click="" style="width: 50px;height: 50px">
                                            <img :src="scope.row.pay_url" alt=""
                                                 style="width: 80px;height: 80px">
                                        </div>
                                    </el-popover>
                                </div>
                                <div v-else>
                                    无
                                </div>

                        </template>
                    </el-table-column>
                    <el-table-column prop="type" label="类型" v-if="filter.employeeType_id===2 "></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div v-if="filter.employeeType_id===0 && powers.includes(135)">
                                <el-popover
                                        placement="right"
                                        title=""
                                        width="270"
                                        trigger="click">
                                    <div class="qrcode_box">
                                        <div style="text-align: center">
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="action"
                                                    :on-preview="handlePreview"
                                                    :on-remove="handleRemove"
                                                    :file-list="fileList"
                                                    :limit="1"
                                                    list-type="picture">
                                                <el-button size="small" type="primary">本地上传</el-button>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <el-button slot="reference" @click="handleUploadUrl(scope.row.id)">点击上传</el-button>
                                </el-popover>
                            </div>
                            <el-button v-if="filter.employeeType_id===1 && powers.includes(135)" size="mini" @click="handleDistributionStudent(scope.row.id)">分配学生</el-button>
                            <!--<el-button v-if="employeeType_id===2 && powers.includes(135)" size="mini" @click="handleSecondDistributionStudent(scope.row.second_headTeacher_id)">分配学生</el-button>-->
                        </template>
                    </el-table-column>

                </el-table>
                <!--分页-->

            </div>
            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }

    .left-menu {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        li {
            &:hover {
                color: #6f42c1;
                background: rgba(0, 123, 255, 0.05);
                border-radius: 5px;
                cursor: pointer;
            }
            padding: 0 10px;
            height: 40px;
            display: flex;
            align-items: center;
            list-style: none;
            font-size: 14px;

            &.active {
                color: #fff;
                background: rgba(111, 66, 193, 0.61);
                border-radius: 5px;
            }
            span {
                font-size: 12px;
                display: none;
                color: #fff
            }
        }
    }
</style>

<script>
    export default {
        name: 'index',
        data() {
            return {
                path:"/employee/list",
                employee_id:'',
                loading: 'true',
                employees: {},
                fileList:[],
                filter:{
                    employeeType_id: 0,
                    employee_id:''
                },

                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                distributionStudent:{
                    grades_id:[],
                    school_id:'',
                    headTeacher_id:'',
                    semesters_id:'',
                    grades:[],
                    schools:[],
                    headTeachers:[],
                    semesters:[],
                    loading:false,
                },
                search_employees:[],
                dialog_storeHeadTeacher:{
                    employee_id:'',
                    button_loading:false,
                },
                dialog_storeSecondHeadTeacher:{
                    employee_id:'',
                    type:'',
                    types:[
                        {
                            id:1,
                            name:'客服'
                        },
                        {
                            id:2,
                            name:'线上'
                        }
                    ],
                    button_loading:false,
                },
                dialog_distributionSecondHeadTeacher:{
                    headTeachers:[{
                        name:'',
                        connects:[{
                            secondHeadTeacher_name:'',
                            disabled:false,
                            id:'',
                            name:''
                        }]
                    }],
                    button_loading:false,
                    first_connect_second_headTeachers:[],
                }
            }
        },
        created() {
            this.handleCreate();
            this.handleSearchEmployee('');
        },
        computed: {
            orderEmployees: function () {
                return this._.values(this.employees);
            },
            powers(){
                return this.$store.state.config.powers;
            },
            action(){
                return "https://server.modijiaoyu.com/api/employee/url?employee_id="+this.employee_id
            },
        },
        methods: {
            handleCreate(){
                this.$wApi.addListen(this.path,this.handleData);
                this.$wApi.send(this.path,'index',{
                    'pageSize': 10,
                    'page': 1,
                    'employeeType_id':this.filter.employeeType_id,
                    'employee_id':this.filter.employee_id,
                });
                this.loading = true;
            },

            handleData(event,data){
                switch (event) {
                    case 'index':
                        if (Object.keys(data.employees).length !== 0) {
                            this.employees= data.employees
                        } else {
                            this.employees = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'init_distribution_student':
                        this.distributionStudent.grades=data.grades;
                        this.distributionStudent.schools=data.schools;
                        this.distributionStudent.headTeachers=data.headTeachers;
                        this.distributionStudent.semesters=data.semesters;
                        break;
                    case 'searchHeadTeacher':
                        this.distributionStudent.headTeachers=data.searchData;
                        break;
                    case 'searchSchool':
                        this.distributionStudent.schools=data.searchData;
                        break;
                    case 'distribution_student':
                        this.distributionStudent.loading=false;
                        break;
                    case 'init_employee':
                        this.search_employees=data.employees
                        break;
                    case 'searchEmployee':
                        this.search_employees=data.searchData
                        break;
                    case 'store_headTeacher':
                        this.$message({
                            type: 'success',
                            message: '创建班主任成功!'
                        });
                        this.total++
                        this.$set(this.employees,data.employee.id,data.employee)
                        this.dialog_storeHeadTeacher.button_loading=false

                        break;
                    case 'store_headTeacher_error':
                        this.dialog_storeHeadTeacher.button_loading=false
                        break;
                    case 'store_second_headTeacher':
                        this.$message({
                            type: 'success',
                            message: '创建副班主任成功!'
                        });
                        this.total++
                        this.$set(this.employees,data.employee.id,data.employee)
                        this.dialog_storeSecondHeadTeacher.button_loading=false
                        break;
                    case 'store_second_headTeacher_error':
                        this.dialog_storeSecondHeadTeacher.button_loading=false
                        break;
                    case 'get_first_connect_second_headTeacher':
                        this.dialog_distributionSecondHeadTeacher.headTeachers=data.headTeachers;
                        this.dialog_distributionSecondHeadTeacher.first_connect_second_headTeachers=data.first_connect_second_headTeachers;
                        break;
                    case 'update_first_connect_second_headTeacher':
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.dialog_distributionSecondHeadTeacher.button_loading=false
                        break;
                }
            },
            handleExchangePresent(id){
                this.$Win.openModal('/referrerExchangePresent/'+id+ '/edit', 1024, 600, '员工详情');
            },
            handleDistributionStudent(employee_id){
                this.$Win.openModal('Dialog_DistributionStudent', 400, 300, '分配学生',{employee_id:employee_id});
            },
            handleUploadUrl(user_id){
                this.employee_id=user_id
            },
            handleChange(type) {
                this.filter.employeeType_id = type;
                this.$wApi.send(this.path,'index',{
                    'pageSize': 10,
                    'page': 1,
                    'employeeType_id':this.filter.employeeType_id,
                    'employee_id':this.filter.employee_id,
                });
                this.loading = true;
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.$wApi.send(this.path,'index',{
                    'pageSize': this.currentPageSize,
                    'page': this.currentPage,
                    'employeeType_id':this.filter.employeeType_id,
                    'employee_id':this.filter.employee_id,
                });
                this.loading = true;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.$wApi.send(this.path,'index',{
                    'pageSize': this.currentPageSize,
                    'page': this.currentPage,
                    'employeeType_id':this.filter.employeeType_id,
                    'employee_id':this.filter.employee_id,
                });
                this.loading = true;
            },
            active(type) {
                return this.filter.employeeType_id == type;
            },
            handleStoreHeadTeacher(){
                this.$Win.openModal('Dialog_StoreHeadTeacher', 400, 200, '添加班主任',{});
            },
            handleStoreSecondHeadTeacher(){
                this.$Win.openModal('Dialog_StoreSecondHeadTeacher', 400, 150, '添加副班主任',{});
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleDistributionSecondHeadTeacher(){
                this.$Win.openModal('Dialog_DistributionSecondHeadTeacher', 900, 700, '分配副班主任',{});
            },
            handleSearchEmployee(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchEmployee',
                    'employeeKeyName': query,
                })
            },
        },
    }
</script>
